import { Link } from "react-router-dom";
import { getHotArticles } from "@/mocks/articles";
import ArticleCard from "@/components/base/ArticleCard";

export default function TrendingSection() {
  const hotArticles = getHotArticles(6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 flex items-center justify-center">
              <i className="ri-fire-line text-xl text-primary-500"></i>
            </div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
              今日热门黑料
            </h2>
          </div>
          <Link
            to="/category/yule"
            className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看更多 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {hotArticles.map((article) => (
            <ArticleCard key={article.id} article={article} variant="featured" />
          ))}
        </div>
      </div>
    </section>
  );
}